import { format } from 'date-fns';
import { PickerType } from '../global-state/types';
import { StorePerformanceMonthlyRequest, StorePerformanceRequest, StorePerformanceWeeklyRequest } from '../hooks';
import { getMonthBounds, getWeekBounds } from '../utils';

export enum TransactionFilterType {
  PaymentType = 'paymentType',
  ReceiptSubType = 'receiptSubType',
  OperatorId = 'operatorId',
}

export enum StorePerformanceInterval {
  DAILY = 'Daily',
  WEEKLY = 'Weekly',
  MONTHLY = 'Monthly',
  RANGE = 'Range', // TODO: Backend should add this
}

export const StorePerformanceIntervalMap: Record<PickerType, StorePerformanceInterval> = {
  date: StorePerformanceInterval.DAILY,
  week: StorePerformanceInterval.WEEKLY,
  month: StorePerformanceInterval.MONTHLY,
  range: StorePerformanceInterval.RANGE,
};

export const createStorePerformanceRequest = (params: {
  interval: StorePerformanceInterval;
  currentDate: Date;
}): StorePerformanceRequest => {
  const { interval, currentDate } = params;
  const { weekStart, weekEnd } = getWeekBounds(currentDate);
  const { monthStart, monthEnd } = getMonthBounds(currentDate);

  if (interval === StorePerformanceInterval.MONTHLY) {
    return {
      interval: StorePerformanceInterval.MONTHLY,
      fromDate: format(monthStart as Date, 'yyyy-MM-dd'),
      toDate: format(monthEnd as Date, 'yyyy-MM-dd'),
    } as StorePerformanceMonthlyRequest;
  }

  if (interval === StorePerformanceInterval.WEEKLY) {
    return {
      interval: StorePerformanceInterval.WEEKLY,
      fromDate: format(weekStart as Date, 'yyyy-MM-dd'),
      toDate: format(weekEnd as Date, 'yyyy-MM-dd'),
    } as StorePerformanceWeeklyRequest;
  }

  return {
    interval: StorePerformanceInterval.DAILY,
    date: format(currentDate as Date, 'yyyy-MM-dd'),
  };
};
